import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Oval } from 'react-loader-spinner';

import { NamespacesList } from 'core/enums/common';
import { UserFile } from 'core/types/base';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

import * as Styled from './styled';

interface DeleteFileModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm?: (fileName: string) => void;
	isLoading: boolean;
	currentFile: UserFile | null;
}

export const DeleteFileModal: FC<DeleteFileModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	currentFile,
	isLoading = false,
}) => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const handleConfirmDeleting = () => {
		onConfirm?.(currentFile?.name || '');
	};

	return (
		<InfoModal
			isOpen={isOpen}
			image={<Error />}
			onClose={onClose}
			title={modalTranslate('deleteFileModal.title')}
			description={modalTranslate('deleteFileModal.description')}
			buttons={
				<>
					{isLoading ? (
						<Styled.ConfirmButton variant="outlined" color="error" disabled={isLoading}>
							<Oval
								height={24}
								width={24}
								color="#FB0B24"
								wrapperStyle={{}}
								wrapperClass=""
								visible={true}
								ariaLabel="oval-loading"
								secondaryColor="rgba(0, 0, 0, 0.26)"
								strokeWidth={5}
								strokeWidthSecondary={5}
							/>
						</Styled.ConfirmButton>
					) : (
						<Styled.ConfirmButton variant="outlined" color="error" onClick={handleConfirmDeleting}>
							{modalTranslate('deleteAccountModal.confirm')}
						</Styled.ConfirmButton>
					)}

					<Styled.CancelButton variant="contained" color="error" onClick={onClose}>
						{modalTranslate('deleteAccountModal.cancel')}
					</Styled.CancelButton>
				</>
			}
		/>
	);
};
